export default __webpack_public_path__ + "static/media/pexel.e7114990.svg";